import LzMBase from '@lz-models/commons/Base';

export default class ItemModel extends LzMBase {

    constructor(model) {
        super(model);

        this.hs_code = model?.hs_code || '';
        this.code = model?.code || '';
        this.type_name = model?.type_name || '';
        this.size_name = model?.size_name || '';
        this.quality_name = model?.quality_name || '';
        this.default_price = +(model?.default_price || 0);
    }

    static parseArray(data) {
        return LzMBase.parseArray(data, ItemModel);
    }

}
